export const useBackgroundColor = (phase?: string, color?: string): string => {
  return phase !== "Preliminary" && color && color !== "" ? color : "blue";
};
